export default __webpack_public_path__ + "static/media/loader.b75b820d.gif";